import { postApi } from '../lib/api';

/**
 * Email Service
 * The server builds every email from the database; the browser only says which
 * registration it's about.
 */

/**
 * Resend the registration confirmation email to the dancer email on file.
 * (The first one is sent by the server when payment completes.)
 */
export const resendConfirmationEmail = (registrationId) =>
  postApi('/api/send-confirmation-email', { registrationId });
